import { z } from "zod";
import { actorViewSchema, personSchema } from "./people.js";
// Un Task come lo vedono l'agenda e la scheda del Lead (piano M5, Task 16; D12): in M5 soltanto il richiamo. Sta in un modulo
// suo, che non importa `leads.ts`, perché la scheda del Lead lo porta (`openTask`) e l'agenda (`tasks.ts`) porta a sua volta le
// righe dei Lead: così nessuno dei due moduli importa l'altro.
//
// Gli elenchi ripetono quelli dello schema e del dominio (`@gioia365/db`: `tasks.ts`; `@gioia365/domain`: `tasks.ts`), che i
// contratti non importano: un test del server li confronta voce per voce.
/** `open` da fare, `done` fatto (con una chiamata o a mano), `canceled` annullato. */
export const TASK_STATUSES = ["open", "done", "canceled"];
/** Come è stato fatto: con una chiamata in uscita valida al Lead, oppure segnato «Fatto» a mano. */
export const TASK_COMPLETIONS = ["called", "done_manually"];
/** La priorità (proposta del 27 settembre 2026): alta per un Task scaduto o concordato con il Lead. */
export const TASK_PRIORITIES = ["high", "normal"];
/**
 * Un Task: il Lead, il tipo, la scadenza (istante ISO), «Concordato con il Lead», l'assegnatario con il suo nome di adesso, chi
 * l'ha creato (l'istantanea di allora) e quando, l'ultima volta che il server lo ha scritto (`setAt`), lo stato, la priorità di
 * adesso, il completamento (quando, come e con quale chiamata) e la versione dei comandi («Sposta», «Fatto», «Annulla»: `409
 * version_conflict`).
 */
export const taskViewSchema = z.object({
    id: z.string(),
    leadId: z.string(),
    type: z.enum(["callback", "disco", "demo"]),
    dueAt: z.string(),
    agreedWithLead: z.boolean(),
    assignee: personSchema,
    createdBy: actorViewSchema,
    createdAt: z.string(),
    /**
     * L'`updated_at` del Task: per uno aperto l'ultima volta che è stato fissato (la nascita, l'ultimo «Sposta», l'unione dei Lead),
     * per uno chiuso la chiusura. È l'istante che il server confronta con la nascita di una chiamata per completare il richiamo
     * (ruling Q55): la postazione lo usa per sapere se la chiamata appena finita lo completa.
     */
    setAt: z.string(),
    status: z.enum(TASK_STATUSES),
    priority: z.enum(TASK_PRIORITIES),
    completedAt: z.string().nullable(),
    completion: z.enum(TASK_COMPLETIONS).nullable(),
    completedCallId: z.string().nullable(),
    version: z.number().int(),
    /**
     * Soltanto per disco e demo (R7): la durata, il link Meet restituito da Google (mai uno inventato), lo stato del calendario e
     * l'esito. Le scritture degli appuntamenti hanno le loro rotte (`appointments.ts`).
     */
    appointment: z
        .object({
        minutes: z.number().int(),
        meetUrl: z.string().nullable(),
        calendarState: z.enum(["created", "not_connected", "pending", "failed"]),
        result: z.enum(["held", "no_show"]).nullable(),
    })
        .optional(),
});
//# sourceMappingURL=task-view.js.map